import { UntypedFormGroup } from '@angular/forms';

import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { BOOKING_FORM_INPUTS, INVALID } from '@booking/constants/forms.constants';
import { TravelerItemUI, TravelerRoomUI } from '@pax/entities/pax-ui';
import { TravelerTypes } from '@pax/entities/traveler-info';

export function validAllFormSections(form: UntypedFormGroup): boolean {
  const validEmail = form.get(BOOKING_FORM_INPUTS.EMAIL).valid;
  const validPhone = form.get(BOOKING_FORM_INPUTS.PHONE).valid;
  const validTravelers = form.get(BOOKING_FORM_INPUTS.TRAVELERS).valid;
  const validBilling = form.get(BOOKING_FORM_INPUTS.BILLING)?.status !== INVALID;
  const validTerms = form.get(BOOKING_FORM_INPUTS.TERMS).valid;
  const validExtraTerms = form.get(BOOKING_FORM_INPUTS.EXTRA_TERMS) ? form.get(BOOKING_FORM_INPUTS.EXTRA_TERMS).valid : true;
  const validCivitatisTerms = form.get(BOOKING_FORM_INPUTS.CIVITATIS_TERMS) ? 
    form.get(BOOKING_FORM_INPUTS.CIVITATIS_TERMS).valid : true;
  const validExtraQuestions = form.get(BOOKING_FORM_INPUTS.EXTRA_QUESTIONS) ? 
    form.get(BOOKING_FORM_INPUTS.EXTRA_QUESTIONS).status !== INVALID : true;
  return validEmail && validPhone && validTravelers && validBilling && validTerms && 
    validExtraTerms && validCivitatisTerms && validExtraQuestions;
}

export function isValidPaxSectionByTypes(
  form: UntypedFormGroup, passengerListUI: TravelerItemUI[], guestListUI: TravelerRoomUI[], bookingType: TravelBookingType,
): boolean {
  switch (bookingType) {
    case TravelBookingType.AUTOS:
    case TravelBookingType.BUSES:
    case TravelBookingType.FLIGHTS:
    case TravelBookingType.FLIGHTS_BY_SECTOR:
    case TravelBookingType.ACTIVITIES:
      return validPaxSectionFormByPassengerListUI(form, passengerListUI, bookingType);
    case TravelBookingType.HOTELS:
    case TravelBookingType.PACKAGE_AIR:
      return validPaxSectionFormByGuestPerRoomListUI(form, guestListUI, bookingType);
    default:
      return false;
  }
}

function validPaxSectionFormByPassengerListUI(
  form: UntypedFormGroup, passengerListUI: TravelerItemUI[], bookingType: TravelBookingType
): boolean {
  switch (bookingType) {
    case TravelBookingType.AUTOS:
      return form.get(BOOKING_FORM_INPUTS.TRAVELERS).valid && !!passengerListUI[0]?.defaultData;
    case TravelBookingType.BUSES:
      const adults = passengerListUI.filter(passengerUI => passengerUI.TravelerType === TravelerTypes.ADULTS);
      return form.get(BOOKING_FORM_INPUTS.TRAVELERS).valid && adults.every(adult => !!adult.defaultData);
    default:
      return form.get(BOOKING_FORM_INPUTS.TRAVELERS).valid && passengerListUI.every(passengerUI => !!passengerUI.defaultData);
  }
}

function validPaxSectionFormByGuestPerRoomListUI(
  form: UntypedFormGroup, guestListUI: TravelerRoomUI[], bookingType: TravelBookingType
): boolean {
  switch (bookingType) {
    case TravelBookingType.HOTELS:
      return form.get(BOOKING_FORM_INPUTS.TRAVELERS).valid &&
        guestListUI.every(roomUI => roomUI.roomGuests.every((guestUI, index) => index === 0 ? !!guestUI.defaultData : true));
    case TravelBookingType.PACKAGE_AIR:
      return form.get(BOOKING_FORM_INPUTS.TRAVELERS).valid &&
        guestListUI.every(roomUI => roomUI.roomGuests.every(guestUI => !!guestUI.defaultData));
  }
}


export const exportedForTesting = {
  validPaxSectionFormByPassengerListUI,
  validPaxSectionFormByGuestPerRoomListUI
}
